import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bcom-honors',
  templateUrl: './bcom-honors.component.html',
  styleUrls: ['./bcom-honors.component.scss']
})
export class BcomHonorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
